import './CreativeResultRow.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import type { CreativeResultRowDisplay } from '../../types';

const [block, element] = bem('creative-result-row');

type CreativeResultRowProps = {
  creativeResult: CreativeResultRowDisplay;
};

const CreativeResultRow = ({ creativeResult }: CreativeResultRowProps): React.JSX.Element => (
  <div className={block()} data-testid="creative-result-row">
    <span className={element('indent')} />
    {creativeResult.isSuccess ? (
      <span className={element('content')}>
        <div>
          <b>Creative ID: </b> {creativeResult.creativeId}
        </div>
        <div>
          <b>Creative Name:</b> {creativeResult.creativeName}
        </div>
        <div>
          <b>Creative Type:</b> {creativeResult.creativeType}
        </div>
      </span>
    ) : (
      <span className={element('content', 'error')}>
        <div>
          <b>Creative Creation Error</b>
        </div>
        <div>
          <b>Creative Name: </b> {creativeResult.creativeName}
        </div>
        <div>
          <b>Creative Type:</b> {creativeResult.creativeType}
        </div>
        {creativeResult.error && (
          <div>
            <div>
              <b>Code:</b> {creativeResult.error.code}
            </div>
            <div>
              <b>Message: </b>
              {creativeResult.error.message}
            </div>
          </div>
        )}
      </span>
    )}
  </div>
);

export default CreativeResultRow;
